<div class="assets-container">
  <div class="assets-card">
    <p-message severity="info">
      <div class="upload-buttons">
        <div>
          <dc-cropper-modal
            id="cropperCardImage"
            #cropperCardImage
            [buttonLabel]="assets()?.image?.url ? 'Cambiar imagen' : 'Cargar una imagen'"
            [imgStorageSettings]="imageStorageSettings()"
            [currentStorage]="assets()?.image"
            (imageUploaded)="onImageUploaded($event, 'image')"
            (onFileSelected)="onFileSelected.emit($event)"></dc-cropper-modal>
        </div>

        <dc-simple-uploader
          [buttonLabel]="assets()?.motion?.url ? 'Cambiar video principal' : 'Agregar video principal'"
          (fileUploaded)="onMotionUploaded($event)"
          [storagePath]="storagePath() + '/motions/file'"
          [accept]="'video/*'"></dc-simple-uploader>

        <dc-simple-uploader
          [buttonLabel]="'Agregar Movimientos'"
          (fileUploaded)="onMotionAdded($event)"
          [storagePath]="storagePath() + '/motions/file'"
          [accept]="'video/*'"></dc-simple-uploader>

        <dc-cropper-modal
          #cropperBanner
          id="cropperBanner"
          [buttonLabel]="assets()?.banner?.url ? 'Cambiar el banner' : 'Cargar un banner'"
          [imgStorageSettings]="bannerImgSettings()"
          [currentStorage]="assets()?.banner"
          (imageUploaded)="onImageUploaded($event, 'banner')"></dc-cropper-modal>

        <dc-cropper-modal
          id="cropperStickers"
          #cropperStickers
          [buttonLabel]="'Agregar sticker'"
          [imgStorageSettings]="stickerStorageSettings()"
          (imageUploaded)="onImageUploaded($event, 'sticker')"></dc-cropper-modal>
      </div>
    </p-message>
    <!-- Banner -->

    <div class="preview-container">
      <img [src]="assets()?.banner?.url || 'assets/defaults/images/default_banner.webp'" class="main-banner-image-card" />
      <div class="main-image-card">
        <img [src]="assets()?.image?.url || 'assets/defaults/images/default_2_3.webp'" />
      </div>

      <div class="motion-container">
        <video #videoPlayer class="main-motion-card" [src]="assets()?.motion?.url" (ended)="onVideoEnded(videoPlayer)" autoplay muted playsinline></video>
        @if(assets()?.motion?.url){
        <p-button class="remove-main-motion-button" (click)="removeMainMotion()" [rounded]="true" [text]="true" icon="pi pi-trash" severity="danger"></p-button>
        }
      </div>
    </div>

    <div class="stickers-container">
      @for (sticker of assets()?.stickers; track sticker.url) {
      <div class="sticker-wrapper">
        <img width="100" [src]="sticker.url" alt="" />
        <p-button (click)="removeSticker(sticker)" class="remove-sticker" icon="pi pi-times" [rounded]="true" [text]="true" severity="danger" />
      </div>
      }
    </div>

    <div class="motions-container">
      @for (motion of assets()?.motions; track motion.url) {
      <div class="motion-wrapper">
        <video width="150" [src]="motion.url" controls playsinline preload="none"></video>
        <p-button (click)="removeMotion(motion)" class="remove-motion-button" icon="pi pi-trash" [rounded]="true" [text]="true" severity="danger"></p-button>
      </div>
      }
    </div>
  </div>
</div>
